module.exports = __webpack_public_path__ + "img/電気回路_2_7_4.d43d9252.png";